import * as types from './types';

const initialState = {
  allocations: {
    sprint: [],
    bypassed: [],
    quick: [],
  },
  purchase: null
}

export default (state = initialState, action) => {
  switch (action.type) {
    case types.GET_ALLOCATIONS_SUCCEEDED:
      return {
        ...state,
        allocations: {
          ...state.allocations,
          sprint: [
            ...state.allocations.sprint,
            ...action.payload.response.data.results
          ]
        }
      }
    case types.GET_BYPASSED_ALLOCATIONS_SUCCEEDED:
      return {
        ...state,
        allocations: {
          ...state.allocations,
          bypassed: [
            ...state.allocations.bypassed,
            ...action.payload.response.data.results
          ]
        }
      }
    case types.GET_QUICK_ALLOCATIONS_SUCCEEDED:
      return {
        ...state,
        allocations: {
          ...state.allocations,
          quick: [
            ...state.allocations.quick,
            ...action.payload.response.data.results
          ]
        }
      }
    case types.CLEAR_ALLOCATIONS:
      return {
        ...state,
        allocations: {
          ...initialState.allocations
        }
      }
    case types.SET_PURCHASE:
      return {
        ...state,
        purchase: action.payload.purchase
      }
    default:
      return state;
  }
}

const getCarrierRenewalUnpaid = (state, carrier) => {
  if (!state.allocations || !state.allocations[carrier]) { return false; }

  return state.allocations[carrier].reduce((result, item) => {
    if (
      !item.purchase ||
      !['complete'].includes(item.purchase.status)
    ) {
      return true;
    }
    else {
      return result;
    }
  }, false);
}

export const getRenewalUnpaid = (state) => {
  return getCarrierRenewalUnpaid(state, 'sprint') || getCarrierRenewalUnpaid(state, 'bypassed') || getCarrierRenewalUnpaid(state, 'quick');
}

export const getRenewalTotal = (state) => state.purchase && state.purchase.cost.total;
export const getRenewalPurchase = (state) => state.purchase;
